import API from "@/services/api";
import {
  IFetchServerElementsParams,
  IFetchServerElementsWithoutActionsParams,
  ServerElementResponse,
  ServerElementData,
} from "../types/serverElements";
import {
  FetchServerActionsData,
  FetchServerActionsResponse
} from "../types/serverActions";
import { secureRoutePath } from "../utils/serverActions";

enum Endpoints {
  DINAMIC_ROUTES_PATH = "/ov_customize/html_dinamic_routes",
  DINAMIC_ELEMENTS_PATH = "/ov_customize/html_dinamic_elements/"
}

const fetchServerActions = () => {
  return new Promise<FetchServerActionsData>(async (resolve, reject) => {
    API.get<FetchServerActionsResponse>({
      endpoint: Endpoints.DINAMIC_ROUTES_PATH,
      versions: [2]
    })
    .then(res => {
      const uniqueRoutes: {[key: string]: boolean} = {};
      const routes: FetchServerActionsData = [];
      for (let action of res.promise.data) {
        const securedRoutePath = secureRoutePath(action.route_path);
        if (securedRoutePath && !uniqueRoutes[securedRoutePath]) {
          action.route_path = securedRoutePath;
          routes.push({
            id: action.id,
            routePath: action.route_path,
            btnDescription: action.btn_description,
            btnTitle: action.btn_title
          });
          uniqueRoutes[securedRoutePath] = true;
        }
      }
      resolve(routes)
    })
    .catch(err => {
      reject(err)
    })
  })
}

const fetchServerElements = ({pageId}: IFetchServerElementsParams) => {
  /*Returns the server actions BUT will return a list if the route_path not duplicated*/
  return new Promise<ServerElementData>(async (resolve, reject) => {
    API.get<ServerElementResponse>({
      endpoint: `${Endpoints.DINAMIC_ELEMENTS_PATH}/${pageId}`,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data.map(elm => ({
        blockHeight: elm.block_height,
        blockWidth: elm.block_width,
        groupName: elm.group_name,
        htmlBlock: elm.html_block,
        id: elm.id,
        name: elm.name,
        priority: elm.priority,
        pageId: elm.page_id
      })))
    })
    .catch(err => {
      reject(err)
    })
  })
}

const fetchServerElementsWithoutActions = ({groupName}: IFetchServerElementsWithoutActionsParams) => {
  /*Returns the server actions BUT will return a list if the route_path not duplicated*/
  return new Promise<ServerElementData>(async (resolve, reject) => {
    API.get<ServerElementResponse>({
      endpoint: Endpoints.DINAMIC_ELEMENTS_PATH,
      versions: [2],
      searchParams: `?group_name=${groupName}`
    })
    .then(res => {
      resolve(res.promise.data.map(elm => ({
        blockHeight: elm.block_height,
        blockWidth: elm.block_width,
        groupName: elm.group_name,
        htmlBlock: elm.html_block,
        id: elm.id,
        name: elm.name,
        priority: elm.priority
      })))
    })
    .catch(err => {
      reject(err)
    })
  })
}

export default {
  fetchServerActions,
  fetchServerElements,
  fetchServerElementsWithoutActions,
};